import { IExecutarAcao } from "../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
import {
    IAtualizarAtendimento,
    ICancelarCaso,
    IReabrirCaso,
} from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { ICasoDinamico } from "../../../Interfaces/Geral/Atendimentos/AtendimentosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

interface responseCaso {
    IDResponse: number;
}

export async function InserirCasoDinamicamenteService(
    requestBody: ICasoDinamico,
    uniqueID?: string
) {
    return Service(
        Axios.post<responseCaso>(
            `/home/atendimentos/inserircasodinamicamente?uniqueID=${
                uniqueID ? uniqueID : ""
            }`,
            requestBody
        )
    );
}

export async function ValidaCasoRecorrenciaService(requestBody: ICasoDinamico) {
    return Service(
        Axios.post<{
            message: string;
            Data: boolean;
        }>(`/home/atendimentos/validacasorecorrencia`, requestBody)
    );
}

export async function AberturaEmMassaAudienciaService(
    requestBody: ICasoDinamico,
    ID_AUDIENCIA?: number
) {
    return Service(
        Axios.post(
            `/home/atendimentos/aberturaemmassaaudiencia?ID_AUDIENCIA=${
                ID_AUDIENCIA ? ID_AUDIENCIA : ""
            }`,
            requestBody
        )
    );
}

export async function ExecutarAcaoAtendimentoService(
    ID_CASO: number,
    ID_ACAO_ETAPA_CASO: number,
    DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO?: string
) {
    return Service(
        Axios.post<IExecutarAcao>(
            `/home/atendimentos/executaracoesdecasosdinamicos?ID_CASO=${ID_CASO}&ID_ACAO_ETAPA_CASO=${ID_ACAO_ETAPA_CASO}&DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );
}

export async function AtualizarAtendimentoService(
    ID_CASO: number,
    requestBody: IAtualizarAtendimento
) {
    return Service(
        Axios.put(
            `/home/atendimentos/editarcaso?ID_CASO=${ID_CASO}`,
            requestBody
        )
    );
}

export async function ValidarUsuarioEditarDescricaoService(ID_CASO: number) {
    return Service(
        Axios.get<boolean>(
            `/home/atendimentos/validausuarioeditardescricao?ID_CASO=${ID_CASO}`
        )
    );
}

export async function AtenderAtendimentoService(ID_CASO: number) {
    return Service(Axios.put(`/home/atendimentos/atender?ID_CASO=${ID_CASO}`));
}

export async function CancelarCasoService(requestBody: ICancelarCaso) {
    return Service(Axios.post(`/home/atendimentos/cancelarcaso`, requestBody));
}

export async function ReabrirCasoService(requestBody: IReabrirCaso) {
    return Service(Axios.post(`/home/atendimentos/reabrircaso`, requestBody));
}
